import React from 'react';

import './ImportantInfo.pcss';

// typograf-enable
const ImportantInfo = () => (
  <div className="ImportantInfo">
    <div className="StartPage-content StartPage-content--Bottoms">
      <div className="StartPage__title">Полезно знать</div>
      <div className="StartPage-important">
        <a
          className="StartPage-important__block"
          href="/otvet-obrazovanie/kak-zapisat-rebenka-v-shkolu/"
        >
          <div className="StartPage-important__type">Инструкция</div>
          <div className="StartPage-important__title">
            Как перевести ребенка в другую школу
          </div>
          <div className="StartPage-important__link">Узнать</div>
        </a>
        <a
          className="StartPage-important__block"
          href="/otvet-obrazovanie/kak-uznat-raspisanie-ege-oge-i-gve/"
        >
          <div className="StartPage-important__type">Инструкция</div>
          <div className="StartPage-important__title">
            Как узнать расписание ЕГЭ, ОГЭ и ГВЭ
          </div>
          <div className="StartPage-important__link">Узнать</div>
        </a>
        <a
          className="StartPage-important__block"
          href="/otvet-obrazovanie/kak-perevesti-bally-za-ege-i-oge-v-pyatiballnuyu-shkalu/"
        >
          <div className="StartPage-important__type">Инструкция</div>
          <div className="StartPage-important__title">
            Как перевести баллы за ЕГЭ и ОГЭ в пятибальную шкалу
          </div>
          <div className="StartPage-important__link">Узнать</div>
        </a>
      </div>
      <a
        href="/otvet-obrazovanie/"
        rel="noopener noreferrer"
        target="_blank"
        className="Link StartPage-important__all-instructions"
      >
        Все инструкции
      </a>
    </div>
  </div>
);

export default ImportantInfo;
